document.addEventListener('click', function (event) {
	if (event.target.closest('.cart-toggle') || event.target.closest('.ajax-cart-overlay')) {
    event.preventDefault();
    //document.querySelector('.ajax-cart').classList.toggle('open');
  }
	if (event.target.matches('.color-toggle')) {
		event.preventDefault();
		let el = event.target;
		let color = el.getAttribute("data-color");
		let id = el.getAttribute("data-product");

		let groups = document.querySelectorAll('.image-group-'+id);
		[].forEach.call(groups, function(el) {
				el.classList.remove('active');
		});
		for(let sib of el.parentElement.children) {
			sib.classList.remove('active')
		}

		el.classList.add('active');
		document.querySelector('.image-group-'+id+'-'+ color).classList.add('active');
	}
	if (event.target.matches('.size-toggle')) {
		event.preventDefault();
		let el = event.target;
		let color = el.getAttribute("data-color");
		let id = el.getAttribute("data-product-id");
		let variant_id = el.getAttribute("data-variant-id");

		for(let sib of el.parentElement.children) {
			sib.classList.remove('active')
		}

		el.classList.add('active');
		document.querySelector('#product-select-'+id+'-'+ color).value = variant_id;
		document.querySelector('.product-form-'+id+'-'+ color).classList.remove('d-none');
	}
  return;
}, false);

function updateCart (cart, cart2) {
  toggleCartLoader();
  var formData = [];
  var formAttributes = {};
  var cartNote = '';
  for (let index = 0; index < cart.elements.length; index++) {
    const element = cart.elements[index];
    if (element.name == 'updates[]') {
      formData.push(parseInt(element.value));
    }
    if (element.name == 'attributes[Ship by date]' && element.value != '') {
      formAttributes['Ship by date'] = element.value;
    }
    if (element.name == 'attributes[Cancel by date]' && element.value != '') {
      formAttributes['Cancel by date'] = element.value;
    }
    if (element.name == 'note') {
      cartNote = element.value;
    }
  }
  formDataJSON = {
    updates: formData,
    attributes: formAttributes,
    note: cartNote
  };
  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formDataJSON),
  }).then(function(){
    fetch('/cart?view=ajax').then(function (response) {
      return response.text();
    }).then(function (html) {
      var parser = new DOMParser();
      var cartHTML = parser.parseFromString(html, 'text/html');
      cart.innerHTML = cartHTML.querySelector('body').innerHTML;
      if (cart2) {
        cart2.innerHTML = cartHTML.querySelector('body').innerHTML;
      }
      bindQuantityFields();
			var giftWrapCount = document.querySelector('#gift-wrap-count').value;
			if (giftWrapCount >= 0) {
				fetch('/cart/update.js', {
			    method: 'POST',
			    credentials: 'same-origin',
			    headers: { 'Content-Type': 'application/json' },
			    body: JSON.stringify({updates:{33645965901960:giftWrapCount}}),
			  }).then(function(){
					refreshCart(false);
				}).catch((error) => {
			    console.error('Error:', error);
			  });
			} else {
				toggleCartLoader();
			}
    }).catch(function (error) {
      console.warn('Something went wrong.', error);
    });
  })
  .catch(function(error) {
    console.warn('Something went wrong.', error);
  });
}

function bindQuantityFields() {
  Array.prototype.slice.call(document.querySelectorAll('.quantity-container')).map(function (container) {
    return {
      input: container.querySelector('.quantity-amount'),
      decrease: container.querySelector('.quantity-decrease'),
      increase: container.querySelector('.quantity-increase'),
      get value () { return parseInt(this.input.value); },
      set value (v) { this.input.value = v; }
    }
  }).forEach(function (item) {
    item.decrease.onclick = function () {
      item.value -= 1;
      item.input.closest('form').dispatchEvent(new Event('change'));
    };
    item.increase.onclick = function () {
      item.value += 1;
      item.input.closest('form').dispatchEvent(new Event('change'));
    };
  });
}

function bindAddToCartForms() {
	let forms = document.querySelectorAll('form[action$="/cart/add"]');
	[].forEach.call(forms, function(form) {
		if (form) {
			if (form.attachEvent) {
				form.attachEvent("submit", addProductToCart);
			} else {
				form.addEventListener("submit", addProductToCart);
			}
		}
	});
};


function toggleCartLoader() {
  var el = document.querySelector('.cart-loader');
  if (el.style.display == "none") {
    el.style.display = "flex";
  } else {
    el.style.display = "none";
  }
}

function addProductToCart(e) {
  e.preventDefault();
  toggleCartLoader();
  let addToCartForm = e.target;
  let formData = new FormData(addToCartForm);
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  }).then(function(cartData){
		var giftWrapToggle = document.querySelector('#gift-wrap-toggle');
		if (giftWrapToggle && giftWrapToggle.checked) {
			fetch('/cart/add.js', {
				method: 'POST',
				credentials: 'same-origin',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({'items': [{'id': 33645965901960,'quantity': 1}]}),
			}).then(function(){
				refreshCart();
			}).catch((error) => {
				console.error('Error:', error);
			});
		} else {
			refreshCart();
		}
  }).catch((error) => {
    console.error('Error:', error);
  });
}

function refreshCart(toggleCartDrawer = true) {
  fetch('/cart?view=ajax').then(function (response) {
    return response.text();
  }).then(function (html) {
    var parser = new DOMParser();
    var cartHTML = parser.parseFromString(html, 'text/html');
    var cart_ajax = document.querySelector('#cart-main-ajax');
    cart_ajax.innerHTML = cartHTML.querySelector('body').innerHTML;
		var cart_main = document.querySelector('#cart-main');
	  if (cart_main) {
			cart_main.innerHTML = cartHTML.querySelector('body').innerHTML;
		}
    bindQuantityFields();
  }).catch(function (error) {
    console.warn('Something went wrong.', error);
  });
	if (toggleCartDrawer) {
		//document.querySelector('.ajax-cart').classList.toggle('open');
	}
  toggleCartLoader();
}

function debounce(func, wait, immediate) {
  var timeout;
  return function executedFunction() {
    var context = this;
    var args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

function predictive_search() {
  var input = document.querySelector('#q');
  const predictiveSearchSection = document.querySelector('#predictive-results');
  var requestResponse;
  //on keyup, start the countdown

  input.addEventListener('input', debounce((event) => {
    predictiveSearchSection.style.display = 'block';
    predictiveSearchSection.innerHTML = '<div class="mx-auto my-3 text-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>';
    var search_term = input.value;
    if (input.value != '') {
      fetch('/search/suggest?q='+search_term+'&resources[type]=product&resources[limit]=10&section_id=site-predictive-search').then((response) => {
        requestResponse = response;
        return response.text();
       })
      .then((text) => {
        if (!requestResponse.ok) {
          console.error(requestResponse.status + ': ' + text);
        }
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-site-predictive-search').innerHTML;
        predictiveSearchSection.innerHTML = resultsMarkup;
      })
      .catch((error) => {
        console.error(error);
      });
    } else {
      predictiveSearchSection.style.display = 'none';
    }
  }, 500));
};

window.addEventListener("load", function () {
  bindQuantityFields();
	bindAddToCartForms();
  predictive_search();
  var cart_main = document.querySelector('#cart-main');
  var cart_ajax = document.querySelector('#cart-main-ajax');
  if (cart_main) {
    document.querySelector('#cart-main').addEventListener('change', function(event){
      updateCart(this, cart_ajax);
    });
  }
  if (cart_ajax) {
    document.querySelector('#cart-main-ajax').addEventListener('change', function(event){
      updateCart(this, cart_main);
    });
  }
	var giftWrapCount = document.querySelector('#gift-wrap-count').value;
	var giftWrapActualCount = document.querySelector('#gift-wrap-actual-count').value;
	if (giftWrapCount != giftWrapActualCount) {
		toggleCartLoader();
		fetch('/cart/update.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({updates:{33645965901960:giftWrapCount}}),
		}).then(function(){
			location.reload();
		}).catch((error) => {
			console.error('Error:', error);
		});
	}
  if(!window.matchMedia("(pointer: coarse)").matches) {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl, {
        html: true
      })
    })
  } 
});

function header () {
  var header = document.querySelector(".header");
  if ( header.getBoundingClientRect().top <= 40) {
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }
  document.querySelector(".navbar-toggler").addEventListener('click', function (event) {
    header.classList.add("scrolled");
    return;
  }, false);
}
window.addEventListener("scroll", header);

function formatMoney(cents) {
	return (cents / 100).toLocaleString("en-US", {style:"currency", currency:"USD"});
}
function handleize (str) {
    str = str.toLowerCase();
    var toReplace = ['"', "'", "\\", "(", ")", "[", "]", "$"];
    for (var i = 0; i < toReplace.length; ++i) {
        str = str.replace(toReplace[i], "");
    }
    str = str.replace(/\W+/g, "-");
    if (str.charAt(str.length - 1) == "-") {
        str = str.replace(/-+\z/, "");
    }
    if (str.charAt(0) == "-") {
        str = str.replace(/\A-+/, "");
    }
    return str
};

function setCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}